import httpRequest from './http-request';
import { isDev, isTest } from '@/utils';
import { handleLearningRequest } from './util';

class Help {
  constructor() {
    this.domain = isDev() ? '/helpapi' : (isTest() ? `//api-academy-test.wps.com` : `//api-academy.wps.com`);
  }

  // 获取用户登录信息
  async getAuthInfo() {
    const url = `${this.domain}/user/info`;
    return await httpRequest.query({
      url,
      options: { method: 'get', withCredentials: true },
    });
  }

  // 获取首页列表
  async getHomeList({ app = 'wps', channel = 'nav' } = {}) {
    const url = `${this.domain}/help_center/client/home/${app}/${channel}`;
    return await httpRequest.query({
      url
    });
  }

  // 退出登录
  async logout() {
    const url = `${this.domain}/user/logout`;
    return await httpRequest.query({
      url,
      options: { method: 'get', withCredentials: true },
    });
  }

  // 获取热门搜索
  async getHotWords() {
    const url = `${this.domain}/search/hot_words`;
    return await httpRequest.query({ url });
  }

  /**
   * 获取提交反馈得token
   */
  async getFbToken() {
    const url = `${this.domain}/feedback/token`;
    const res = await httpRequest.query({ url });
    if (res.code === 200 && res.data && res.data.__hash__) {
      return res.data.__hash__;
    } else {
      return '';
    }
  }

  /**
   * 提交反馈
   */
  async submitFeedback({ feedback, fromChannel, searchResult, hash, ext }) {
    const url = `${this.domain}/search/feedback`;

    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        data: {
          from_channel: fromChannel,
          feedback,
          search_result: searchResult,
          __hash__: hash,
          ext
        },
        withCredentials: true,
      },
    });
  }

  /**
   * 提交评价
   */
  async submitComment({ content, fromChannel, id, isHelp, ext, token, wps_sid }) {

    const url = `${this.domain}/comment`;

    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        data: {
          content,
          id,
          is_help: isHelp,
          ext,
          from_channel: fromChannel,
          __c_token__: token,
          wps_sid,
        },

      },
    });
  }

  /**
   * 获取我的收藏的数据
   * @param {*} type 收藏类型 不传是全部 1 电脑版技巧 11 移动版技巧 2文章 5问答
   * @param {*}
   */
  async getUserFav({ page = 1, limit = 8, type = 1, wps_sid } = {}) {
    const url = `${this.domain}/user/fav?page=${page}&limit=${limit}&type=${type}&wps_sid=${wps_sid}`;
    return await httpRequest.query({ url })
  }

  /**
   * 取消收藏
   * @param {*} id
   */
  async doUnFav({ post_id, wps_sid }) {
    const url = `${this.domain}/user/${post_id}/do_unfav`;
    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        data: {
          wps_sid
        }
      },
    });
  }

  /**
   * 收藏
   * @param {*} id
   */
  async doFav({ post_id, wps_sid }) {
    const url = `${this.domain}/user/${post_id}/do_fav`;
    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        data: {
          wps_sid
        }
      },
    });
  }

  /**
   * 获取视频教程详情页的数据
   * @param {*} id
   */
  async getCourseDetail(id) {
    const url = `${this.domain}/v2/detail/course/${id}}`;
    const data = await httpRequest.query({
      url,
    });
    return handleLearningRequest(data);
  }

  /**
   * 获取问答教程详情页的数据
   * @param {*} id
   * @param {*} sid
   * @param {*} isPreview 是否预览
   */
  async getQuestionDetail(id) {
    const url = `${this.domain}/question/detail/${id}`;
    const data = await httpRequest.query({
      url,
    });

    return handleLearningRequest(data);
  }


  /**
   * 获取视频详情页的推荐列表，仅有视频
   * @param {*} id 视频教程id
   */
  async getCourseHotData({ id, limit = 1 }) {
    const url = `${this.domain}/v2/course/hot/${id}?limit=${limit}`;
    return handleLearningRequest(
      await httpRequest.query({
        url,
      })
    );
  }

  /**
   * 获取视频详情页-推荐列表v2.1，包含视频和文章
   * @param {Number} id 视频教程id
   * @param {Number} limit 获取条目数
   */
  async getCourseHot2Data({ id, limit = 4 }) {
    const url = `${this.domain}/v2/course/recommend/${id}?limit=${limit}`;
    return handleLearningRequest(
      await httpRequest.query({
        url,
      })
    )
  }

  /**
   * 获取问答详情页的推荐列表
   * @param {*} id 问答id
   */
  async getQuestionHotData({ id, limit = 4 }) {
    const url = `${this.domain}/question/hot/${id}?limit=${limit}`;
    return handleLearningRequest(
      await httpRequest.query({
        url,
      })
    );
  }


  /**
   * 获取详情页的下面推荐数据
   * @param {*} id
   */
  async getSeoTrending(id) {
    const url = `${this.domain}/seo/detail/trending/${id}?limit=4`;
    const data = await httpRequest.query({
      url,
    });
    return handleLearningRequest(data);
  }

  /**
   * 获取某个文章、视频的点赞收藏情况
   * @param {*} id
   */
  async getLikeFavState({ post_id, wps_sid }) {
    const url = `${this.domain}/v2/user/like_fav/${post_id}`;
    return handleLearningRequest(
      await httpRequest.query({
        url,
        options: {
          data: {
            wps_sid
          }
        },
      })
    );
  }

  /**
   * 点赞
   * @param {*} id
   */
  async doLike({ post_id, wps_sid }) {
    const url = `${this.domain}/user/${post_id}/like`;
    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        data: {
          wps_sid
        }
      },
    });
  }

  /**
   * 分享上报
   * @param {*} id
   */
  async share({ post_id, wps_sid }) {
    const url = `${this.domain}/share/${post_id}`;
    return await httpRequest.query({
      url,
      options: {
        method: 'post',
        data: {
          wps_sid
        }
      },
    });
  }

};

export default new Help();


// WEBPACK FOOTER //
// ./src/services/api.js